<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/hardware.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Hardware</span>
            </div>
          </router-link>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:23px;">
          </div>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="admin">
            <div class="admin-menu">
                <div class="info-prof" style="display: flex">
                    <div class="info-prof-avatar">
                      <img v-if="userInfoList.profile_picture" :src="userInfoList.profile_picture" alt="">
                      <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                    </div>
                    <div style="margin-left:12px;display:flex;flex-direction:column">
                      <div class="info-prof-name">{{ userInfoList.nickname }}</div>
                      <div class="info-prof-offer">{{ userInfoList.job_title }}</div>
                    </div>
                </div>
            </div>
            <div class="admin-content">
              <div class="admin-wrap">
                <div class="new-user">
                  <div class="new-user-title" style="z-index: 99">
                      <span class="user-new">Hardware Management</span>
                  </div>
                  <div class="user-status-content">
                      <a-table
                          style="margin-top:20px;"
                          :columns="columns"  
                          :rowKey="(record,index)=>{return index}"
                          :pagination="false"
                          :data-source="allUserHardwareInfo" 
                      >
                      </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

const columns = [
  {
    title: 'Model',
    dataIndex: 'device_model',
    align: 'center' 
  },
  {
    title: 'Identifier',
    dataIndex: 'device_identifier',
    align: 'center' 
  },
  {
    title: 'Serial Number',
    dataIndex: 'serial_number',
    align: 'center' 
  },
  {
    title: 'Distribution Time',
    dataIndex: 'distribution_time',
    align: 'center' 
  },
]
export default {
  name: 'Device',
  components: {
    Bug
  },
  data() {
    return {
        columns,                //  列表
        curUserId:"",           //  当前用户id
        userInfoList:"",        //  员工信息
        allUserHardwareInfo:[]  //  获取设备信息
    }
  },
  methods: {
    // 获取员工信息
    getUserInfo() {
      this.infoSpinning = true
      this.$post(api.tool.getUserInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userInfoList = res.list
        }
        this.infoSpinning = false
      })
    },
    // 获取设备信息
    getAllUserHardwareInfo(){
      this.$post(api.tool.getAllGroupHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.allUserHardwareInfo = res.list.filter(item => {
            if(item.employee_id == this.curUserId) {
              return item 
            }
          })
        }
        this.infoSpinning = false
      })
    }
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id

      this.getUserInfo()
      this.getAllUserHardwareInfo()
    } else {
      this.$router.push({ path: '/' })
    }
  },
}

</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}

.container {
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}
/* avatar name */
.info-prof {
  height: 81px;
}
.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}
.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}
.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}
.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

.admin {
  display: flex;
  margin-top: 40px;
}
.admin-menu {
  width: 320px;
}
.admin-wrap {
  background-color: #ffffff;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  width: 800px;
}

.new-user {
  height: 844px;
  width: 800px;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
}
.new-user-title {
  display: flex;
  justify-content: space-between;
  height: 85px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  color: #222222;
}
.user-new {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  margin-top: 22px;
  margin-left: 31px;
}
.user-status-content {
  height: 100%;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
}


</style>
